'use client';

import dynamic from 'next/dynamic';

const ProvidersNoSSR = dynamic(
  () => import('./providers').then((m) => m.Providers),
  { ssr: false }
);

export function ClientProviders({
  children,
  isSsrMobile,
}: {
  children: React.ReactNode;
  isSsrMobile: boolean;
}) {
  return <ProvidersNoSSR isSsrMobile={isSsrMobile}>{children}</ProvidersNoSSR>;
}
